import { IHocSinhSelectRequest } from "../../../models/request/hoc-sinh/IHocSinhSelectRequest";
import { IHocSinhModel } from "../../../models/response/hoc-sinh/IHocSinhModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const objHocSinhViewShortDefine = {
    LOAD_START: {} as IHocSinhSelectRequest,
    LOAD_SUCCESS: [] as IHocSinhModel[],
    LOAD_ERROR: "",
};

export const eHocSinhViewShortActionTypeIds = generateActionTypeIds(objHocSinhViewShortDefine, "HOC_SINH_VIEW_SHORT")
export type IHocSinhViewShortActionTypes = IGenericActionType<typeof objHocSinhViewShortDefine, "HOC_SINH_VIEW_SHORT">
